import { vacationDescConstants } from '../constants'

const initialState = {
    list: null,
    error: null,
    loading: false,
    ajaxSpinner: false,
    ajaxStatus: null,
    ajaxAction: null
}

export default function vacationDescriptions(state = initialState, action) {
    switch (action.type) {
        case vacationDescConstants.LOADING_VACATION_DESC:
            return { ...state, loading: true, error: null }
        case vacationDescConstants.LOADING_VACATION_DESC_ERROR:
            return { ...state, loading: false, error: action.payload }
        case vacationDescConstants.UPDATE_VACATION_DESC:
            return {
                ...state,
                list:
                    state.list === null
                        ? [action.payload]
                        : (state.list.findIndex((x) => x.id === action.payload.id) === -1
                            ? state.list.concat(action.payload)
                            : state.list.map((item) => {
                                return item.id === action.payload.id ? action.payload : item
                            })
                        ).sort((a, b) => (a.name > b.name ? 1 : -1)),
                ajaxAction: 'update',
                loading: false
            }
        case vacationDescConstants.REMOVE_VACATION_DESC:
            return {
                ...state,
                list: state.list.filter((item) => {
                    return item.id !== action.payload.id
                }),
                ajaxAction: 'remove',
                loading: false
            }
        case vacationDescConstants.VACATION_DESC_AJAX_CALL:
            return { ...state, ajaxSpinner: true, ajaxStatus: null }
        case vacationDescConstants.VACATION_DESC_AJAX_SUCCESS:
            return { ...state, ajaxSpinner: false, ajaxStatus: null }
        case vacationDescConstants.VACATION_DESC_AJAX_FAILURE:
            return { ...state, ajaxSpinner: false, ajaxStatus: action.payload }
        default:
            return state
    }
}
